/// <amd-module name="Wiki/PageViews/PageViews" />
import * as React from "react";

import { format } from "VSS/Core/Util/String";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Icon, IconSize } from "VSSUI/Icon";
import { WikiPageDetail } from "Wiki/Clients/Wiki/Contracts/Wiki";
import { IWikiRestClient } from "Wiki/Clients/Wiki/RestClient/Wiki";
import * as Resources from "Wiki/PageViews/Resources";

const MaxDaysForPageViews = 30;

interface IPageViewsState {
    viewCount?: number;
}

interface IPageViewsProps {
    projectId: string;
    wikiId: string;
    pageId: number;
}

class PageViewsComponent extends VssComponent<IPageViewsProps, IPageViewsState> {
    constructor(props: IPageViewsProps, context: IVssComponentContext) {
        super(props, context);
        this.state = {};
    }

    public componentDidMount(): void {
        super.componentDidMount();
        this._loadPageViews();
    }

    public componentDidUpdate(prevProps: Readonly<IPageViewsProps>, prevState: Readonly<IPageViewsState>): void {
        super.componentDidUpdate(prevProps, prevState);
        if (this.props.pageId !== prevProps.pageId) {
            this._loadPageViews();
        }
    }

    public render(): JSX.Element | null {
        const { viewCount } = this.state;
        return viewCount !== undefined ? (
            <div className="page-view-section flex-row font-size-mm">
                <Icon className="padding-right-8" iconName="EntryView" size={IconSize.medium} />
                <span>{viewCount === 1 ? Resources.OnePageViewText : format(Resources.PageViewsText, viewCount)}</span>
            </div>
        ) : null;
    }

    private _loadPageViews(): void {
        const wikiClient = this.context.pageContext.getRestClient<IWikiRestClient>("IWikiRestClient");
        this.trackPromise(wikiClient.getPageData(this.props.projectId, this.props.wikiId, this.props.pageId, MaxDaysForPageViews)).promise.then(
            (pageDetails: WikiPageDetail) => {
                let pageViewCount = 0;
                if (pageDetails.viewStats) {
                    for (let i = 0; i < pageDetails.viewStats.length; i++) {
                        pageViewCount += pageDetails.viewStats[i].count;
                    }
                }
                this.setState({ viewCount: pageViewCount });
            }
        );
    }
}

VssComponent.register("Wiki.WikiPageViews", PageViewsComponent);
